import React, { useState, useEffect } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { listToolCategories, listTools } from '../graphql/queries';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import './Tools.scss';

const Tools = () => {
  const [toolCategories, setToolCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTools();
  }, []);

  const fetchTools = async () => {
    try {
      const toolData = await API.graphql(
        graphqlOperation(listToolCategories, {
          filter: { _deleted: { ne: true } }
        })
      );
      
      const categories = await Promise.all(
        toolData.data.listToolCategories.items.map(async (category) => {
          const tools = await API.graphql(
            graphqlOperation(listTools, {
              filter: { 
                toolCategoryID: { eq: category.id },
                _deleted: { ne: true }
              }
            })
          );
          
          return {
            ...category,
            tools: tools.data.listTools.items
          };
        })
      );
      
      setToolCategories(categories);
      setIsLoading(false);
    } catch (err) {
      console.error('Error fetching tools:', err);
      setError('Failed to load tools');
      setIsLoading(false);
    }
  };

  const handleToolClick = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener noreferrer');
    }
  };

  if (isLoading) return <div className="tools-loading">Loading tools...</div>;
  if (error) return <div className="tools-error">{error}</div>;

  return (
    <div className="tools-container">
      {toolCategories.map((category) => (
        <div key={category.id} className="tool-category">
          <h3 className="category-title">{category.title}</h3>
          {category.description && (
            <p className="category-description">{category.description}</p>
          )}
          <div className="tools-list">
            {category.tools.map((tool) => (
              <div 
                key={tool.id} 
                className={`tool-item ${tool.url ? 'clickable' : ''}`}
                onClick={() => handleToolClick(tool.url)}
              >
                <span className="tool-title">{tool.title}</span>
                {tool.url && (
                  <FontAwesomeIcon 
                    icon={faExternalLinkAlt} 
                    className="tool-link-icon"
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Tools;
